import "./style.scss";
import { FC } from "react";
import { ISideBarListItemObj } from "@/src/types/sideBar";
import { sideBarMenuSvg } from "@/src/constants/sidebar";
import { SidebarSvgExportConst } from "@/src/svg/sidebar/SidebarSvgExport";

interface ISidebarNavSecondProps {
  title: string;
  sideBarMenuFilters: ISideBarListItemObj[];
  checkedIds: string[];
  onToggle: (id: string) => void;
}

const SidebarNavSecond: FC<ISidebarNavSecondProps> = ({ title, sideBarMenuFilters, checkedIds, onToggle }) => {
  return (
    <div className="sidebar-second-nav">
      <div className="sidebar-second-nav-title">
        <p>{title}</p>
      </div>
      <ul className="sidebar-second-nav-ul">
        {sideBarMenuFilters.map((item) => {
          const isChecked = checkedIds.includes(item.id);
          return (
            <li key={item.id} className="sidebar-second-nav-ul-li" onClick={() => onToggle(item.id)}>
              <div className="sidebar-second-nav-ul-li-icon">
                {sideBarMenuSvg.map((itemSvg) => (itemSvg.id === item.id ? <itemSvg.svg key={itemSvg.id} /> : null))}
              </div>
              <p className="sidebar-second-nav-ul-li-text">{item.text}</p>
              <div className="sidebar-second-nav-ul-li-checkbox">
                {isChecked ? <SidebarSvgExportConst.CheckboxCheckSvg /> : <SidebarSvgExportConst.CheckboxUnCheckSvg />}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SidebarNavSecond;
